<template>
  <div class="main-action-container">
    <div style="width: 33%;">
      <div class="validate-container ">
        <div class="heading-items">
          <p class="actionHedaing">Payroll Actions</p>
          <!-- <img src="@/assets/info-2.svg" style="width: 20px;"> -->
        </div>
        <div v-for="(item, index) in lockActions" :key="index" :class="['pay-actions', { 'disabled': item.disabled }]"
          @click="!item.disabled && openDialog(item)" style="margin-bottom: 15px; margin-top: 20px;"
          :title="'pending actions'">
          <div class="pay-header">
            <p class="pay-ptext">{{ item.name }}</p>
          </div>
          <p :style="{ color: getDotColor(item.PayrollMonthLockValidation[0].status) }" class="dot">●</p>
          <span :style="{ color: getDotColor(item.PayrollMonthLockValidation[0].status) }" class="status-text">{{
            getStatusText(item.PayrollMonthLockValidation[0].status) }}</span>
        </div>
      </div>
    </div>
    <div style="width: 30.5%;">
      <div class="statutory-container">
        <div class="statutory-header">
          <p class="actionHedaing">Statutory Reports</p>
          <img src="@/assets/info-2.svg" style="width: 20px;"
            :title="'Download the statutory report for the selected month'">
        </div>


        <div>
          <div v-for="(item, index) in items" :key="index" class="pending-container" style="gap: 10px;">
            <div class="provident-fund">
              <img :src="item.icon" style="width: 40px;">
              <p class="pending-pText">{{ item.text }}</p>
            </div>
            <div class="download-icon" @click="downloadReport(item)"></div>
          </div>
        </div>


      </div>
    </div>
    <div style="width: 30.5%;">
      <div class="statutory-container">
        <div class="statutory-header">
          <p class="actionHedaing">Standard Reports</p>
          <img src="@/assets/info-2.svg" style="width: 20px;"
            :title="'Download the standard report for the selected month'">
        </div>
        <div>
          <div v-for="(item, index) in standardReports" :key="index" class="payrollAction-container">
            <div class="provident-fund" @click="redirectToReports(item)">
              <img :src="item.icon" style="width: 40px;">
              <p class="payroll-pText">{{ item.text }}</p>
            </div>
            <div class="download-icon" @click="downloadStandardReport(item)"></div>
          </div>
        </div>
      </div>
    </div>
    <pop-up-message popupHeaderMessage="Warning" v-if="showPopUp" :message="dialogMessage" :popupType="'Warning'">

      <template v-slot:bottomContent>
        <div v-if="actionType === 'finalizePayroll' || actionType === 'lockPayroll'"
          style="display: flex;margin-bottom: 20px; flex-direction: column; align-items: flex-start;">
          <p style="font-size: 18px; font-weight: 500;">Verified By</p>
          <div style="display: flex; gap: 20px;">

            <p>Name :</p>
            <p>{{ nameOfActioPerson }}</p>
          </div>
          <div style="display: flex; gap: 20px;">
            <p>Date : </p>
            <p>{{ currentDateAndTime }}</p>
          </div>
          <div style="display: flex; flex-direction: column;">
            <p style="margin-bottom: 0px;">Remarks:</p>
            <textarea class="form-control custom-textarea margintop-16" rows="15" name="selectEmp" v-model="details"
              placeholder="Enter the Remarks"></textarea>
          </div>
        </div>
        <div v-if="handleSelectedEmployeesFlags">
          <p class="selectedFeature" v-if="actionType == 'releasePayslip' || actionType == 'releaseITSheet'">Please release generate paysilps for all employees, only after that you can release payslip and IT sheet</p>

        </div>
        <div v-else>
         <p></p>
        </div>
        <!-- <v-divider class="divider"></v-divider> -->
        <div class="popup-btn-group">
          <button class="btn-popup-cancel" type="button" @click="closeModal()">
            <b>No</b>
          </button>
          <button class="btn-popup" type="button" @click="confirmAndExecuteAction":disabled="handleSelectedEmployeesFlags && (actionType === 'releasePayslip' || actionType === 'releaseITSheet')">
            <b>Agree</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <pop-up-message popupHeaderMessage="Warning" v-if="showValidation" :message="validationMessage"
      :popupType="'Warning'">
      <template v-slot:bottomContent>
        <v-divider class="divider"></v-divider>
        <div class="popup-btn-group">
          <button class="btn-popup" type="button" @click="closeValidation()">
            <b>OK</b>
          </button>
        </div>
      </template>
    </pop-up-message>
    <generate-payroll-report-popup :generatePayload="generatePayload" v-if="showReportModal"
    :warningMessage="warningMessage"
    @selectedEmployeesFlag="handleSelectedEmployeesFlag"
      @closeReportModal="closeReportModal"></generate-payroll-report-popup>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";
import generatePayrollReportPopup from './generatePayrollReportsPopUp.vue'

const getPathForStep = (entity_index, step_name) => {
  return `/dashboard/${entity_index}/${step_name}`
}
export default {
  components: {
    generatePayrollReportPopup

  },
  props: {
    date: {
      type: String,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialogMessage: '',
      showLockPopupModal: false,
      btnText: 'Run Payroll',
      idSelectedAction: '',
      warningMessage: 'You can release the payslip and IT sheets only after they have been generated for all employees.*',
      showLoader: false,
      showPopUp: false,
      handleSelectedEmployeesFlags: false,
      nameOfActioPerson: '',
      nameOfDailog: '',
      details: '',
      showReportModal: false,
      generatePayload: {
   
      },
      additionalFieldsArray:["dob", "gender", "father_name", "mother_name", "bank_name", "passport_number", "passport_expiry_date","employee_has_pf","pf_number","pf_date","employee_pf_contribution_rule","employer_pf_contribution_rule","pan","employee_has_esi","esi_number","employee_has_lwf","employee_has_pt","bank_account_number","ifsc_code","account_holder_name","branch_name","marital_status","adhar_number","emergency_contact_number","phone_number","address_1","address_2","uan_number","pf_relationship","is_metro","city","state","country","pin","mobile_number","personal_email_id","blood_group","udf","pran_number"],
      currentDateAndTime: '',
      showValidation: false,
      validationMessage: '',
      dialogHeading: '',
      hoveredItem: null,
      errmsg: "",
      toast: false,
      showDatePicker: false,
      lockActions: [],
      locaActionSort: [],
      items: [
        { icon: require('@/assets/pfIcon.svg'), text: 'Provident Fund (PF)' },
        { icon: require('@/assets/esicIcon.svg'), text: 'Employees’ State Insurance Corporation (ESIC)' },
        { icon: require('@/assets/lwfIcon.svg'), text: 'Labour Welfare Fund (LWF)' },
        { icon: require('@/assets/ptIcon.svg'), text: 'Professional Tax (PT)' }
      ],
      standardReports: [
        { icon: require('@/assets/salReg.svg'), text: 'Salary Register' },
        { icon: require('@/assets/ITcomp.svg'), text: 'IT computation' },
        { icon: require('@/assets/YTDRep.svg'), text: 'Variance report' },
        { icon: require('@/assets/salReg.svg'), text: 'Income Tax' }
      ]
    };

  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      selectedEmployeesData: state => state.payroll.paygroups.employeeData,
      isSelected: state => state.payroll.paygroups.isSelectedEmployees,
      totalPayGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      entities: state => state.onboard.legal_entities.data

    }),
    formattedYear() {
      return this.date.split('-')[0];
    },
    formattedMonth() {
      const monthNumber = this.date.split('-')[1];
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return monthNames[parseInt(monthNumber, 10) - 1];
    },
    formattedSmallMonth() {
      const monthNumber = this.date.split('-')[1];
      const monthNames = [
        'jan', 'feb', 'mar', 'apr', 'may', 'jun',
        'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
      ];
      return monthNames[parseInt(monthNumber, 10) - 1];
    },
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },

  },

  mounted() {
    // this.fetchLockActionsInsert()
    this.fetchLockActionsGet()
    // this.fetchLockActionsPatch()
    this.getValidation()
  },
  created(){
    this.generatePayload = {
            month: this.formattedSmallMonth,
            year: this.formattedYear,
          }
  },
  methods: {
    ...mapActions({
      act_download_esi_v2_report: "dashboard/payroll/newReports/downloadESIv2report",
      //downloadSRtwo: "dashboard/payroll/reports/Reports/downloadSalaryRegisterReportTwo",
      act_download_pt_report: "dashboard/payroll/newReports/downloadPTReport",
      act_get_payroll_reports_generation_flag: 'dashboard/payroll/monthlypayroll/lockPayroll/getPayrollReportGenerationFlag',
      act_download_lwf_report: "dashboard/payroll/newReports/downloadLWFreport",
      act_lockPayroll: 'dashboard/payroll/monthlypayroll/lockPayroll/lock',
      act_download_pf_report: "dashboard/payroll/newReports/downloadPFreport",
      // act_download_income_tax_download: "payroll/paygroups/fetchdIncomeTaxDownload",
      act_download_income_tax: "dashboard/payroll/newReports/downloadIncomeTaxReport",
      act_download_salary_variance: "dashboard/payroll/newReports/downloadsalaryVariance",
      act_download_tds_report: "dashboard/payroll/newReports/downloadTDSReport",
      act_download_it_compuation_report: "dashboard/payroll/reports/Reports/downloadITComputationV2Report",
      act_download_salary_register_report:"dashboard/payroll/reports/Reports/downloadSalaryRegisterReportTwoNew",
      act_postLockActions: "payroll/paygroups/fetchdetailsLockActionsInsert",
      act_getLockActions: "payroll/paygroups/fetchdetailsLockActions",
      act_patchLockActions: "payroll/paygroups/fetchdetailsLockActionsPatch",
      act_validation: "payroll/paygroups/fetchValidationDetails",
      act_exact_cycle: "payroll/paygroups/fetchExactCycle",
      act_release_payslip_ess: 'dashboard/payroll/monthlypayroll/lockPayroll/releasePayslipESS',
      act_release_it_sheet_ess: 'dashboard/payroll/monthlypayroll/lockPayroll/releaseITSheetESS',

      

    }),
    openDialog(item) {
      if (!this.validateSelection()) {
        return;
      }
      this.dialogHeading = item.name
      this.idSelectedAction = item.id
      this.dialogMessage = this.getMessageForItem(item.name);
      this.showPopUp = true;

      switch (item.name) {
        case 'Lock Payroll':
          this.actionType = 'lockPayroll';
          break;

        case 'Finalize Payroll':
          this.actionType = 'finalizePayroll';
          break;

        case 'Generate Payslip & IT Sheet':
          this.actionType = 'generatePayslip';
          break;

        case 'Release Payslip':
          this.actionType = 'releasePayslip';
          break;

        case 'Release IT sheet':
          this.actionType = 'releaseITSheet';
          break;

        default:
          this.actionType = null;
          break;
      }

    },
    async cycleDate() {
      try {
        let obj = { 'le_id': this.le_id };
        let res = await this.act_exact_cycle(obj)
      } catch (e) {
        console.log(e)

      }
    },
    handleSelectedEmployeesFlag(flag) {
    this.handleSelectedEmployeesFlags = flag
  },
    async releaseITSheet() {
      try {
        if(this.formattedMonth) {
          let obj = {
            le_id : this.le_id,
            financial_year: this.formattedYear,
            month: this.formattedSmallMonth
          }
          let res = await this.act_release_it_sheet_ess(obj);
        } else {
          console.log('error')
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error
      }
    },
    async releasePayslip(){
      try {
        if(this.formattedMonth){
          let obj = {
            le_id : this.le_id,
            financial_year: this.formattedYear,
            month: this.formattedSmallMonth
          }
          let res = await this.act_release_payslip_ess(obj)
        }else{
         console.log('error')
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error
      }
    },
    async confirmAndExecuteAction() {
      try {
        const res = await this.fetchLockActionsPatch(this.idSelectedAction, this.actionType);

        switch (this.actionType) {
          case 'lockPayroll':
            // await this.lockPayroll();
            break;

          case 'finalizePayroll':
            // await this.finalizePayroll();  
            break;

          case 'generatePayslip':
            // await this.generateReports();
            break;

          case 'releasePayslip':
            // await this.releasePayslip(); 
            break;

          case 'releaseITSheet':
            // await this.releaseITSheet()
            // await this.releaseITSheet();  
            break;

          default:
            console.log('No action type matched.');
            break;
        }
        this.showPopUp = false;
      } catch (error) {
        console.log(error, 'error');
        this.toast = true;
        this.errmsg = error.message;
      }
    },
    getMessageForItem(name) {
      switch (name) {
        case 'Finalize Payroll':
          return 'Are you sure you want to Finalize Payroll?'
        case 'Generate Payslip & IT Sheet':
          return 'Are you sure you want to generate the payslip & it sheet?';
        case 'Lock Payroll':
          return 'Are you sure you want to lock the payroll?';
        case 'Release Payslip':
          return 'Are you sure you want to release the payslip?';
        case 'Release IT sheet':
          return 'Are you sure you want to release the IT sheet?';
        default:
          return 'Are you sure you want to proceed?';
      }
    },
    closeModal() {
      this.showPopUp = false;
    },
    closeReportModal() {
      this.showReportModal = false;
    },
    async generateReports() {
      this.showReportModal = true;

      if (this.formattedMonth) {
        let generationStatus = await this.getPayrollReportsGenerationStatus();
        if (generationStatus.payrollStatus) {
          this.showReportModal = true;
        } else {
          this.toast = true;
          this.errmsg = generationStatus.statusMessage;
        }
      } else {
        this.toast = true;
        this.errmsg = "Please select a month to generate Payslip and Tax sheet"
      }
    },
    async getPayrollReportsGenerationStatus() {
      try {
        let obj = {
          legal_entity_id: this.le_id,
          month: this.formattedMonth,
          financial_year: this.formattedYear
        }
        let response = await this.act_get_payroll_reports_generation_flag(obj);
        if (response && response.data) {
          return {
            payrollStatus: response.data.payload.data,
            statusMessage: response.data.message
          }
        }
      } catch (error) {
        this.toast = true
        this.errmsg = err
      }
    },

    closeValidation() {
      this.showValidation = false
    },
    validateSelection() {
      if (!this.formattedMonth || !this.formattedYear || !this.le_id) {
        this.validationMessage = "Please select Payroll Month and Paygroup.";
        this.showValidation = true;
        return false;
      }
      return true;
    },
    async fetchLockActionsInsert() {
      try {
        const res = await this.act_postLockActions({
          month: this.getSelectedMonthEnumByName(
            this.formattedMonth
          ), year: this.formattedYear, le_id: this.le_id
        })
        if (res) {
          this.fetchLockActionsGet();
        } else {
          this.fetchLockActionsInsert()
        }
      } catch (error) {
        console.log(error, 'error')
      }
    },
    async getValidation() {
      try {
        const res = await this.act_validation({
          month: this.getSelectedMonthEnumByName(
            this.formattedMonth
          ), year: this.formattedYear, le_id: this.le_id
        })

      } catch (e) {
        console.log(e)
      }
    },
    formatToDesiredDate(dateString) {
      const date = new Date(dateString);
      const options = {
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Kolkata',
      };

      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
    async fetchLockActionsGet() {
      try {
        let auditData = [];
        const res = await this.act_getLockActions({
          month: this.getSelectedMonthEnumByName(this.formattedMonth),
          year: this.formattedYear,
          le_id: this.le_id
        });
        auditData = res.data.payload.result.map((item) => {
            const validation = item.PayrollMonthLockValidation[0];
            return {
              name: validation.modified_by_name,
              id: item.id,
              email: validation.modified_by_email,
              date: this.formatToDesiredDate(validation.updated_at),
              description: item.name,
            };
          });
          this.$emit('audit-data-emitted', auditData);
        if (Array.isArray(res.data.payload.result)) {
          if (res.data.payload.result.length === 0) {
            await this.fetchLockActionsInsert(); // Ensure async handling
          } else {
            console.log("Result is not empty:", res.data.payload.result);
          }
        } else {
          console.error("Expected result to be an array, but got:", res.data.payload.result);
        }
        this.lockActions = res.data.payload.result;

        const desiredOrder = [
          "Finalize Payroll",
          "Generate Payslip & IT Sheet",
          "Release Payslip",
          "Release IT Sheet",
          "Lock Payroll"
        ];
        this.nameOfActioPerson = res.data.payload.name
        this.nameOfDailog = res.data.payload
        this.currentDateAndTime = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });

        const normalizeName = (name) => name.trim().toLowerCase();
        this.lockActions.sort((a, b) => {
          const indexA = desiredOrder.findIndex(item => normalizeName(item) === normalizeName(a.name));
          const indexB = desiredOrder.findIndex(item => normalizeName(item) === normalizeName(b.name));
          return (indexA === -1 ? desiredOrder.length : indexA) -
            (indexB === -1 ? desiredOrder.length : indexB);
        });
        const statuses = {};
        this.lockActions.forEach(action => {
          statuses[normalizeName(action.name)] = action.PayrollMonthLockValidation[0] &&
            action.PayrollMonthLockValidation[0].status;
        });
        const isFinalizeComplete = statuses['finalize payroll'] === 'complete';
        this.lockActions.forEach(action => {
          const actionName = normalizeName(action.name);
          if (actionName === 'lock payroll') {
            action.disabled = !isFinalizeComplete ||
              statuses['generate payslip & it sheet'] !== 'complete' ||
              statuses['release payslip'] !== 'complete' ||
              statuses['release it sheet'] !== 'complete';
          } else if (["release payslip", "release it sheet", "lock payroll"].includes(actionName)) {
            action.disabled = !isFinalizeComplete;
          }
        });
      } catch (error) {
        console.log(error, 'error');
      }
    },
    async fetchLockActionsPatch(itemId, actionType) {
      try {
        const remarks = String(this.details).trim();
        const res = await this.act_patchLockActions({
          month: this.getSelectedMonthEnumByName(
            this.formattedMonth
          ), year: this.formattedYear, le_id: this.le_id, payroll_lock_action_id: itemId, remarks: remarks === "" ? null : remarks

        })
        if (res.status == 200) {
          this.fetchLockActionsGet()
          this.details = []
          switch (actionType) {
        case 'generatePayslip':
          // Call generateReports for generatePayslip
          this.showReportModal = true;  // Open the report modal
          // this.generatePayload = this.prepareGeneratePayload(); // Prepare payload for generating the report
          await this.generateReports();  // Call the generateReports API
          break;

        case 'lockPayroll':
          await this.lockPayroll();
          break;

        case 'finalizePayroll':
          // Uncomment this if finalizePayroll function is needed
          // await this.finalizePayroll();
          break;

        case 'releasePayslip':
          await this.releasePayslip()
        
          // Uncomment this if releasePayslip function is needed
          // await this.releasePayslip();
          break;

        case 'releaseITSheet':
        await this.releaseITSheet()
          // Uncomment this if releaseITSheet function is needed
          // await this.releaseITSheet();
          break;

        default:
          console.log('No matching actionType for further actions.');
          break;
      }
        }

      } catch (error) {
        console.log(error, 'error')
      }
    },

    async lockPayroll() {
      try {
        let obj = {
          'le_id': this.le_id,
          'month': this.getSelectedMonthEnumByName(
            this.formattedMonth
          ),
          'year': this.formattedYear,
          'lock': "1",
          'unlock': "0"
        };
        let res = await this.act_lockPayroll(obj);
        if(res){
          this.cycleDate()
          if(res){
          window.location.reload(); 
          }
        }
        this.showPopUp = false
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getEsiReportV2() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
          status: "both"
        }
        this.showLoader = true;
        let res = await this.act_download_esi_v2_report(
          obj
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
    //Download PT Report
    async getPtReport() {
      try {

        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
          status: "both"
        }
        this.showLoader = true;
        let res = await this.act_download_pt_report(
          obj
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
    //Download PF Report
    async getPfReport() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
          status: "both"
        }
        this.showLoader = true;
        let res = await this.act_download_pf_report(
          obj
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        this.handleError(error, 'Failed to download PF report.');
      }
    },
    //Download LWF Report
    async getLwfReport() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
        }
        this.showLoader = true;
        let res = await this.act_download_lwf_report(
          obj
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    redirectToReports(item) {
      const entityIndex = this.$route.params.entity_index;
      let path;
      switch (item.text) {
        case "Salary Register":
          path = getPathForStep(entityIndex, 'reports');
          this.$router.push({
            path: path,
            query: {
              reportType: "Payroll",
              subReportType: "Salary Register"
            }
          });
          break;

        case "IT computation":
          path = getPathForStep(entityIndex, 'reports');
          this.$router.push({
            path: path,
            query: {
              reportType: "Payroll",
              subReportType: "Salary Register"
            }
          });
          break;

        default:
          break;
      }
    },
    downloadStandardReport(item) {
      if (!this.validateSelection()) {
        return; // Stop if validation fails
      }
      switch (item.text) {
        case 'Income Tax':
          this.downloadIncomeTaxReport()
          break;
        case 'Variance report':
          this.getSalaryVariance()
          break;
        case 'IT computation':
          this.getIncomeTaxCompuationStatement()
          break;
        case 'Salary Register':
          this.getSalRegister()
          break;
        default:
          break;
      }
    },
    async downloadIncomeTaxReport() {
      try {
        this.showLoader = true;
        let res = await this.act_download_tds_report({
          le_id: this.le_id,
          month: this.formattedMonth,
          year: this.formattedYear,
          status: "both"
        });
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
    async getSalaryVariance() {
      try {
        let res = await this.act_download_salary_variance(
          {
            le_id: this.le_id,
            month: this.formattedSmallMonth,
            financialYear: this.formattedYear,
            status: "both"
          }
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
    async getSalRegister() {
      try {
        this.showLoader = true;
        let res = await this.act_download_salary_register_report(
          {
            le_id: this.le_id,
            month: this.formattedSmallMonth,
            financialYear: this.formattedYear,
            status: "both",
            additional_fields: this.additionalFieldsArray,
          }
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },
    async getIncomeTaxCompuationStatement() {
      try {
        this.showLoader = true;
        let res = await this.act_download_it_compuation_report(
          {
            le_id: this.le_id,
            month: this.formattedSmallMonth,
            year: this.formattedYear,
            status: "both"
          }
        );
        this.showLoader = false;
        this.toast = false;

      } catch (error) {
        setTimeout(() => {
          this.toast = true;
          this.showLoader = false;
          this.errmsg = error;
        }, 1000);
      }
    },

    downloadReport(item) {
      if (!this.validateSelection()) {
        return; // Stop if validation fails
      }

      switch (item.text) {
        case 'Employees’ State Insurance Corporation (ESIC)':
          this.getEsiReportV2();
          break;
        case "Professional Tax (PT)":
          this.getPtReport();
          break;
        case "Labour Welfare Fund (LWF)":
          this.getLwfReport();
          break;
        case "Provident Fund (PF)":
          this.getPfReport();
          break;
        default:
          this.showError('Invalid report type.');
      }
    }
    ,
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec"; // PL-2264
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    showSuccess(message) {
      this.toast = true;
      this.errmsg = message;
    },

    showError(message) {
      this.toast = true;
      this.errmsg = message;
    },
    getDotColor(status) {
      switch (status) {
        case 'complete':
          return '#62BDBD'; // Green color for completed
        case 'incomplete':
          return '#FF0000'; // Red color for incomplete
        case 'pending':
          return '#FFA500'; // Orange color for pending
        default:
          return '#000000'; // Default color
      }
    },
    getStatusText(status) {
      switch (status) {
        case 'complete':
          return 'Completed';
        case 'incomplete':
          return 'Incomplete';
        case 'pending':
          return 'Pending';
        default:
          return 'Unknown';
      }
    },
    getStatusClass(item) {
      if (item.completed === true) {
        return 'completed-status';
      } else if (item.completed === false) {
        return 'error-status';
      } else if (item.completed === 'pending') {
        return 'pending-status';
      }
    },
    toggleDatePicker() {
      this.showDatePicker = !this.showDatePicker;
    },
    handleDateSelect(val) {
      this.selectedDate = val;
      this.showDatePicker = false;
    },
    closeDatePicker() {
      this.showDatePicker = false;
    },

  },
};
</script>
<style lang="scss" scoped>
.validate-container {
  background: white;
  height: 455px;
  margin-bottom: 20px;
  padding: 20px 25px;
  border: 2px solid #eeeeee;
  border-radius: 18px;
  // overflow-y: auto;
  // scrollbar-width: thin;
  // scrollbar-color: #c1c1c1 #f5f5f5;
}

::v-deep .form-control {
  width: 350px;
  min-height: 50px;
  max-height: auto;
}

// .validate-container::-webkit-scrollbar {
//   width: 8px;
// }

// .validate-container::-webkit-scrollbar-track {
//   background: #f5f5f5;
// }

// .validate-container::-webkit-scrollbar-thumb {
//   background-color: #c1c1c1;
//   border-radius: 10px;
//   border: 10px solid #f5f5f5;
// }
::v-deep .divider.theme--light.v-divider {
  background-color: #62BDBD;
}

.popup-btns.animated {
  margin-left: 0px;
}

.pending-container,
.payrollAction-container {
  background: white;
  //   min-width: 410px;
  // max-width:410px ;
  //width: 100%;
  margin-bottom: 20px;
  // min-height: 505px;
  // max-height: 505px;
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
  padding: 21px 20px;
  border: 2px solid #eeeeee;
  border-radius: 18px;

  //box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  &:hover {
    background-color: #F2F2F2;
    /* Change background color on hover */
    border: 0.5px solid#DBCBFF;
  }
}

.actionHedaing {
  margin-bottom: 0px;
  color: #59419A;
  font-size: 18px;
  font-weight: 500;
}

.v-timeline-item {
  padding-bottom: 0px;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px)
}

::v-deep .modal-content .message-text {
  margin-bottom: 20px !important;
}

::v-deep .v-timeline-item__dot--small .v-timeline-item__inner-dot {
  width: 12px !important;
  height: 12px !important;
  margin: 6px !important;
}
.selectedFeature {
    color: red;
    font-weight: 600;
    font-size: 1rem;
}


.heading-items {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-popup-cancel {
  display: block;
  border-radius: 4px;
  min-width: 150px;
  padding: 0px 10px;
  height: 35px;
  background-color: #ffffff;
  border: #5D409F solid 2px;
  color: #5D409F;
}

.pay-actions {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid #C1C1C1;
  border-radius: 16px;
  // width: 335px; 

  // margin-bottom: 25px;
  padding: 18px;
}

.status-text {
  display: none;
  position: absolute;
  right: 20px;
  /* Adjust positioning as needed */
  top: 0;
  //background-color: white;
  //border: 1px solid #ddd;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
}

.dot:hover+.status-text {
  display: inline-block;
}

.pay-ptext {
  color: #4B4B4B;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 0px;
}

.pay-header {
  display: flex;
  gap: 20px;
  align-items: center;
}

.dot {
  margin-bottom: 0px;
}

.statutory-container {
  display: flex;
  flex-direction: column;
}

.statutory-header {
  display: flex;
  margin-bottom: 20px;
  gap: 10px;
}

.provident-fund {
  display: flex;
  gap: 20px;
  align-items: center;
}

.main-action-container {
  display: flex;
  gap: 20px;
  margin: 20px 30px;
  width: 100%;
}

.pending-pText {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}

.payroll-pText {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
}

.download-icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-image: url('~@/assets/downloadPayroll.svg');
  /* Default image */
  background-size: contain;
  background-repeat: no-repeat;
}

/* Hover effect */
.download-icon:hover {
  background-image: url('~@/assets/newpayrolldownload.svg');
  /* Hover image */
}
</style>